module.exports = __webpack_public_path__ + "static/img/微信.d021c60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/微信.jpg
// module id = 9K6T
// module chunks = 1